import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateRegistroContableRequest } from '@models/registroContable/createRegistroContableRequest.model';
import { RegistroContableDto } from '@models/registroContable/registroContableDto.model';
import { UpdateRegistroContableRequest } from '@models/registroContable/updateRegistroContableRequest.model';
import { RegistroContableFilter } from '@models/registroContable/registroContableFilter.model';
import { CreatePruebaInformativaRequest } from '@models/pruebas/pruebaInformativa/createPruebaInformativaRequest.model';
import { UpdatePruebaInformativaRequest } from '@models/pruebas/pruebaInformativa/updatePruebaInformativaRequest.model';
import { PruebaInformativaDto } from '@models/pruebas/pruebaInformativa/pruebaInformativaDto.model';
import { PruebaInformativaFilter } from '@models/pruebas/pruebaInformativa/pruebaInformativaFilter.model';

@Injectable({
  providedIn: 'root'
})
export class PruebaInformativaService {

  constructor(private http:HttpClient) {
  }

  create(createPruebaInformativaRequest:CreatePruebaInformativaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/PruebaInformativa/Create",createPruebaInformativaRequest);
  }

  update(updatePruebaInformativaRequest:UpdatePruebaInformativaRequest):Observable<any>
  {
    return  this.http.put<any>("/api/PruebaInformativa/Update",updatePruebaInformativaRequest);
  }

  getAll():Observable<PruebaInformativaDto[]> {
    return   this.http.get<PruebaInformativaDto[]>("/api/PruebaInformativa/GetAll");
  }

  getAllByIdExpediente(idExpediente:number):Observable<PruebaInformativaDto[]> {
    return   this.http.get<PruebaInformativaDto[]>("/api/PruebaInformativa/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getAllByFilter(pruebaInformativaFilter: PruebaInformativaFilter):Observable<PruebaInformativaDto[]> {
    return   this.http.post<PruebaInformativaDto[]>("/api/PruebaInformativa/GetAllByFilter",pruebaInformativaFilter);
  }


  getById(id:number):Observable<PruebaInformativaDto>{
    return  this.http.get<PruebaInformativaDto>("/api/PruebaInformativa/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/PruebaInformativa/Delete?id=" + id);
    else
      return of(null)
  }

}
